module.exports = __webpack_public_path__ + "img/news1-5.dab51bc6.jpeg";